import { put, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/settings/messages";
import { camelizeKeys, keysToSnakeCase } from "lib/helpers";

function* createAdminAdvanceSetting(action) {
  const { success, data, error } = yield* makeRequest.post("/pay_advance_levels", keysToSnakeCase(action.payload));

  if (success && data) {
    const advanceSettings = camelizeKeys(data.body.pay_advance_levels);
    yield all([
      put(actions.setAdminAdvanceSettings(advanceSettings)),
      put(
        actions.newSuccessEvent({
          message: messages.ADMIN_ADVANCE_SETTINGS_UPDATE_SUCCESS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_CREATING_ADMIN_ADVANCE_SETTING,
    });
  }

  return null;
}

export default createAdminAdvanceSetting;
